import { Stack, Typography } from '@mui/material'
import { GridGroupNode, useGridApiContext } from '@mui/x-data-grid-premium'
import { useTranslation } from 'react-i18next'
import { ROW_GROUPING_NONE_GROUPING_TEXT_VALUE } from '../helpers'

interface Props {
  columnHeaderName: string
  value: string
  id: string | number
}

export const RowGroupingColumnTableCell: React.FC<Props> = ({ columnHeaderName, value, id }) => {
  const { t } = useTranslation('common')
  const apiRef = useGridApiContext()

  const tableCellText = value === ROW_GROUPING_NONE_GROUPING_TEXT_VALUE ? t('row-grouping.none-row-grouping-value') : value

  // A server data source that caps a group's loaded children (see useRequestsDataSource) leaves the
  // group's true size on the row while fewer children are actually loaded — surface the difference.
  const totalChildCount = apiRef.current?.getRow(id)?.childCount
  const loadedChildCount = apiRef.current?.getRowNode<GridGroupNode>(id)?.children?.length
  const isTruncated =
    typeof totalChildCount === 'number' &&
    loadedChildCount !== undefined &&
    loadedChildCount > 0 &&
    loadedChildCount < totalChildCount

  return (
    <Stack
      onClick={(e) => {
        e.stopPropagation()
        if (!apiRef.current?.getRowNode) return // Fixes bug when you click on grouped row name instead of the expand button
        apiRef.current.setRowChildrenExpansion(id, !apiRef.current.getRowNode<GridGroupNode>(id)?.childrenExpanded)
      }}
      direction="row"
      gap={1}
      alignItems="center"
    >
      <Typography variant="body-regular">{columnHeaderName}:</Typography>
      <Typography variant="body-medium">{tableCellText}</Typography>
      {isTruncated && (
        <Typography variant="body-regular" color="text.muted">
          {t('row-grouping.showing-first-of', { shown: loadedChildCount, total: totalChildCount })}
        </Typography>
      )}
    </Stack>
  )
}
